import * as types from './types'
import global from '@/plugins/global'

export default {
  [types.SET_DAYS](state, days) {
    state.retrospectiveDay = days
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
  },
  [types.SET_SORT_DIR](state, sortDir) {
    state.sortDir = sortDir
  },
  [types.SET_ORDER_BY](state, orderBy) {
    state.orderBy = orderBy
  },
  [types.SET_QUEUE](state, data) {
    state.queue = data
  },
  [types.SET_WORKORDER_QUEUE](state, data) {
    state.workOrderQueue = data
    state.workOrderQueueFiltered = data
  },
  [types.FILTER_WORKORDER_QUEUE](state, filterBy) {
    state.workOrderQueueFiltered = []
  },
  [types.SET_TECH_QUEUE](state, data) {
    try {
      if (data !== undefined && data !== null) {
        for (let tech of data) {
          tech.elapsedTime = global.dates.elapsedTime(tech.userStatusDate, tech.dispatchStatus, tech.workOrderStatus)
        }
      }
    } catch (e) {
      console.error(e)
    }
    state.techQueue = data
    state.techQueueFiltered = data
  },
  [types.FILTER_TECH_QUEUE](state, filterBy) {
    state.techQueueFiltered = []
  },
  [types.SET_TOOL_QUEUE](state, data) {
    try {
      if (data !== undefined && data !== null) {
        for (let tech of data) {
          tech.elapsedTime = global.dates.elapsedTime(tech.lastEditedTime, '', '')
        }
      }
    } catch (e) {
      console.error(e)
    }
    state.toolQueue = data
    state.toolQueueFiltered = data
  },
  [types.FILTER_TOOL_QUEUE](state, filterBy) {
    state.toolQueueFiltered = []
  },
  [types.SET_DISPATCH_LOG](state, data) {
    state.dispatchLog = data
  },
  [types.SET_BREAKDOWN_SUMMARY](state, data) {
    state.breakdownSummary = []
    try {
      if (data !== undefined && data !== null) {
        if (data.current !== null) {
          state.breakdownSummary.push({
            id: 0,
            name: 'Submitted',
            current: data.current[0].submitted,
            min: data.submitted.min,
            max: data.submitted.max,
            avg: data.submitted.avg,
            total: data.submitted.counts
          })
          state.breakdownSummary.push({
            id: 1,
            name: 'Scheduled',
            current: data.current[0].scheduled,
            min: data.scheduled.min,
            max: data.scheduled.max,
            avg: data.scheduled.avg,
            total: data.scheduled.counts
          })
          state.breakdownSummary.push({
            id: 2,
            name: 'Assigned',
            current: data.current[0].assigned,
            min: data.assigned.min,
            max: data.assigned.max,
            avg: data.assigned.avg,
            total: data.assigned.counts
          })
          state.breakdownSummary.push({
            id: 3,
            name: 'Reassigned',
            current: data.current[0].reassigned,
            min: data.reassigned.min,
            max: data.reassigned.max,
            avg: data.reassigned.avg,
            total: data.reassigned.counts
          })
          state.breakdownSummary.push({
            id: 4,
            name: 'Scan in Progress',
            current: data.current[0].scanprogress,
            min: data.scanInProgress.min,
            max: data.scanInProgress.max,
            avg: data.scanInProgress.avg,
            total: data.scanInProgress.counts
          })
          state.breakdownSummary.push({
            id: 5,
            name: 'Scan Completed',
            current: data.current[0].scancomplete,
            min: data.scanCompleted.min,
            max: data.scanCompleted.max,
            avg: data.scanCompleted.avg,
            total: data.scanCompleted.counts
          })
          state.breakdownSummary.push({
            id: 6,
            name: 'Report to CS',
            current: data.current[0].reportcs,
            min: data.reportToCS.min,
            max: data.reportToCS.max,
            avg: data.reportToCS.avg,
            total: data.reportToCS.counts
          })
          state.breakdownSummary.push({
            id: 7,
            name: 'Waiting on Shop',
            current: data.current[0].waitshop,
            min: data.waitShop.min,
            max: data.waitShop.max,
            avg: data.waitShop.avg,
            total: data.waitShop.counts
          })
          state.breakdownSummary.push({
            id: 8,
            name: 'Closed',
            current: data.closed,
            min: null,
            max: null,
            avg: null,
            total: null
          })
          state.breakdownSummary.push({
            id: 9,
            name: 'Voided RO',
            current: data.voidedRO,
            min: null,
            max: null,
            avg: null,
            total: null
          })
          state.breakdownSummary.push({
            id: 10,
            name: 'Total',
            current: data.current[0].assigned + data.current[0].closed + data.current[0].reassigned +
              data.current[0].reportcs + data.current[0].scancomplete + data.current[0].scanprogress +
              data.current[0].scheduled + data.current[0].submitted + data.current[0].voidedro,
            min: null,
            max: null,
            avg: null,
            total: null
          })
        }
      }
    } catch (e) {
      console.error(e)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/mutations.js